import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface NoBookingsStateProps {
  onSearchProviders?: () => void;
  favoriteProviderSlug?: string | null;
}

const NoBookingsState = ({ onSearchProviders, favoriteProviderSlug }: NoBookingsStateProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (favoriteProviderSlug) {
      navigate(`/provider/${favoriteProviderSlug}`);
    } else {
      onSearchProviders?.();
    }
  };

  return (
    <Card className="p-12 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <Calendar className="h-8 w-8 text-gray-600" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">No upcoming appointments</h3>
      <p className="text-gray-600 mb-6">Your upcoming appointments will appear here when you book</p>
      <Button 
        className="bg-gray-900 hover:bg-gray-800 text-white"
        onClick={handleClick}
      >
        {favoriteProviderSlug ? "Book now" : "Search providers"}
      </Button>
    </Card>
  );
};

export default NoBookingsState;
